import { useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Checkbox, FormControlLabel, FormLabel, RadioGroup, Typography  } from '@mui/material';

import { usePages } from '../hooks/usePages';

import { TablePaginationActions } from '../helpers/TablePaginationActions';

import { TablePaddingStyle, TableTheadStyle } from '../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../styles/DialogStyle';

import { BuscarPersona } from '../connections/comun/PersonaConnection';

import { PersonaProps } from '../interfaces/comun/PersonaInterface';
import { PersonaParteProps } from '../interfaces/comun/ParteInterface';

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
    seleccionarPersona:     ( persona: PersonaParteProps ) => void;
}

export const DialogBuscarPersona = ( { openDialog, handleCloseDialog, seleccionarPersona }: Props ) => {

    const [rows, setRows] = useState<PersonaProps[]>( [] );

    const [curp, setCurp] = useState( '' );
    const [nombres, setNombres] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [tipoPersona, setTipoPersona] = useState( 1 );
    const [razonSocial, setRazonSocial] = useState( '' );
    const [rfc, setRfc] = useState( '' );
  
    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );    

    const [loading, setLoading] = useState( false );

    const handleSeleccionar = ( persona: PersonaParteProps ) => {

        seleccionarPersona( persona )
        CerrarModal();

    }
  
    const Buscar = async () => {

        setLoading( true );

        setRows( [ ] );
        resetPage();

        const params = {           
            nombres: nombres,
            apellido1: apellido1,
            apellido2: apellido2,
            curp: curp,
            rfc: rfc,
            razonSocial: razonSocial, 
            idTipoPersona: tipoPersona,  
        };

        await BuscarPersona( params ).then( resp => {           

            setTimeout(() => {

                setRows( resp );
                
                setLoading( false );

            }, 700);                

        });
    }    

    const CerrarModal = () => {

        handleCloseDialog();

        setCurp( '' );
        setNombres( '' );
        setApellido1( '' );
        setApellido2( '' );
        setTipoPersona(1);
        setRfc( '' );
        setRazonSocial( '' );
        
        setRows( [] );
    }

    const clearFields = ( tipoPersona: number ) => {

        setCurp( '' );
        setNombres( '' );
        setApellido1( '' );
        setApellido2( '' );
        setRfc( '' );
        setRazonSocial( '' );

        setTipoPersona(tipoPersona);
        setRows( [] );
    }

    return (
        <>
            <Dialog 
                maxWidth='md' 
                fullWidth={true}
                open={ openDialog } 
            >

                <DialogTitle>
                    Buscar Persona
                </DialogTitle>
            
                <DialogContent sx={ DialogContentStyle }>
                    
                    <Grid container spacing={3}>    
                      
                        <Grid size={{ md: 4, xs: 1 }} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }} >
                            <FormLabel>Tipo de persona: </FormLabel>
                        </Grid>
                            
                        <Grid size={{ md: 8, xs: 10 }}>
                            <RadioGroup row>
                                <Grid container spacing={3} sx={{ width: '100%' }}>
                                    <Grid size={{ md: 4, xs: 6 }} >
                                        <FormControlLabel value="Física" control={ <Checkbox checked={ tipoPersona === 1 } onChange={ () => clearFields(1) } /> } label="Física" />
                                    </Grid>
                                    <Grid size={{ md: 8, xs: 6 }} >
                                        <FormControlLabel value="Moral" control={ <Checkbox checked={ tipoPersona === 2 } onChange={ () => clearFields(2) } /> } label="Moral" />     
                                    </Grid>                                                            
                                </Grid>
                            </RadioGroup>
                        </Grid>                                

                        {
                            tipoPersona === 1
                            &&                                                     
                                <>

                                    <Grid size={{ md: 4, xs: 12 }} >

                                        <TextField
                                            fullWidth
                                            label="Curp"
                                            name="curp"
                                            variant="outlined"
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}           
                                            value={ curp }            
                                            onChange={ ( e ) => { setCurp( e.target.value.toLocaleUpperCase() ); } }
                                        />

                                    </Grid> 
                    
                                    <Grid size={{ md: 8, xs: 12 }} >

                                        <TextField
                                            fullWidth
                                            label="Nombre(s)"
                                            name="nombre"
                                            variant="outlined"   
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}               
                                            value={ nombres }          
                                            onChange={ ( e ) => { setNombres( e.target.value ); } }
                                        />

                                    </Grid>

                                    <Grid size={{ md: 4, xs: 12 }} >

                                        <TextField
                                            fullWidth
                                            label="Apellido 1"
                                            name="apellido1"
                                            variant="outlined"          
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}                
                                            value={ apellido1 }            
                                            onChange={ ( e ) => { setApellido1( e.target.value ); } }             
                                        />

                                    </Grid>

                                    <Grid size={{ md: 4, xs: 12 }} >

                                        <TextField
                                            fullWidth
                                            label="Apellido 2"
                                            name="apellido2"
                                            variant="outlined"          
                                            slotProps={{
                                                input: {
                                                    autoComplete: 'off'
                                                },
                                                inputLabel: {
                                                    shrink: true,
                                                }
                                            }}                      
                                            value={ apellido2 }       
                                            onChange={ ( e ) => { setApellido2( e.target.value ); } }                             
                                        />

                                    </Grid>                                     

                                </>                            
                        }

                        {
                            tipoPersona === 2                    
                            &&                             
                                <>
                                    <Grid size={{ md: 12, xs: 12 }} >
                                        <TextField
                                            fullWidth
                                            label="Razon social"
                                            name="razonSocial"
                                            variant="outlined"    
                                            value={ razonSocial }      
                                            autoComplete="off"                             
                                            onChange={ ( e ) => { setRazonSocial( e.target.value ); } }                       
                                        /> 
                                    </Grid>

                                    <Grid size={{ md: 6, xs: 6 }} >
                                        <TextField
                                            fullWidth
                                            label="RFC"
                                            name="rfc"
                                            variant="outlined"     
                                            value={ rfc }        
                                            onChange={ ( e ) => { setRfc( e.target.value ); } }    
                                            autoComplete="off"                      
                                        />
                                    </Grid>
                                </>                            
                        }

                        <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'right', marginTop: '0.5em' }} >
                            
                            <Button  
                                fullWidth                   
                                variant="contained"     
                                loading={ loading }    
                                onClick={ Buscar }
                                disabled={ ( nombres.trim() === ''|| nombres.length < 3 ) && 
                                    ( apellido1.trim() === '' || apellido1.length < 3 ) && 
                                    ( apellido2.trim() === '' || apellido2.length < 3 ) && 
                                    ( curp.trim() === ''|| curp.length < 5 ) &&
                                    ( rfc.trim() === '' || rfc.length < 3 ) && 
                                    ( razonSocial.trim() === '' || razonSocial.length < 3 )
                                }
                            >
                                Buscar
                            </Button >

                        </Grid>           

                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 2 }} >
                            
                            <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                       
                                <Table sx={{ minWidth: 500 }}>           
                            
                                    {
                                        tipoPersona === 1                  
                                        &&                                       
                                            <TableHead sx={{ ...TableTheadStyle }}>
                           
                                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Curp</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%' }}>Nombre(s)</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Apellido 1</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Apellido 2</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell>
                                                </TableRow>

                                            </TableHead>                                           
                                    }

                                    {
                                        tipoPersona === 2               
                                        &&                                       
                                            <TableHead sx={{ ...TableTheadStyle }}>
                           
                                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>RFC</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'60%' }}>Razón social</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell>
                                                </TableRow>

                                            </TableHead>                                           
                                    }

                                    {
                                        tipoPersona === 1               
                                        &&                                       
                                            <TableBody>

                                                {
                                                    (
                                                        rowsPerPage > 0
                                                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : rows
                                                    ).map( ( { idPersona, curp, nombres, apellido1, apellido2, nombreCompleto, idTipoPersona }, index ) => (

                                                        <TableRow key={ index }>
                                                            <TableCell> { curp } </TableCell>
                                                            <TableCell> { nombres } </TableCell>
                                                            <TableCell> { apellido1 } </TableCell>
                                                            <TableCell> { apellido2 } </TableCell>
                                                            <TableCell> 
                                                                <Button 
                                                                    size="small"
                                                                    variant="contained"
                                                                    sx={{ fontSize: 12 }}
                                                                    onClick={ () => { handleSeleccionar( { idPersona, nombreCompleto: nombreCompleto ?? '', idTipoPersona: idTipoPersona ?? 0, } ); } }
                                                                >
                                                                    Seleccionar
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>

                                                    ))
                                                }

                                                {
                                                    rows.length === 0 
                                                    &&                                                    
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={7}
                                                                align="center"
                                                            >
                                                                {
                                                                    loading
                                                                    ?
                                                                        <Typography variant="caption" color='secondary'> Buscando.... </Typography>
                                                                    :
                                                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                                }
                                                            </TableCell>
                                                        </TableRow>                                                    
                                                }

                                            </TableBody>                                           
                                    }

                                    {
                                        tipoPersona === 2               
                                        &&    
                                            <TableBody>

                                                {
                                                    (
                                                        rowsPerPage > 0
                                                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : rows
                                                    ).map( ( { idPersona, nombreCompleto, rfc, razonSocial, idTipoPersona }, index ) => (

                                                        <TableRow key={ index }>
                                                            <TableCell> { rfc } </TableCell>
                                                            <TableCell> { razonSocial } </TableCell>
                                                            <TableCell> 
                                                                <Button 
                                                                    size="small"
                                                                    variant="contained"
                                                                    sx={{ fontSize: 12 }}
                                                                    onClick={ () => { handleSeleccionar( { idPersona, nombreCompleto: nombreCompleto ?? '', idTipoPersona: idTipoPersona ?? 0, } ); } }
                                                                >
                                                                    Seleccionar
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>

                                                    ))
                                                }

                                                {
                                                    rows.length === 0 
                                                    &&                                                   
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={6}
                                                                align="center"
                                                                style={{ fontWeight: '600', fontSize: 14 }}
                                                            >
                                                                {
                                                                    loading
                                                                    ?
                                                                        <Typography variant="caption" color='secondary'> Buscando.... </Typography>
                                                                    :
                                                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                                }
                                                            </TableCell>
                                                        </TableRow>                                                    
                                                }

                                            </TableBody>   
                                    }

                                    <TableFooter>

                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[ ]}
                                                colSpan={6}
                                                count={rows.length}                                        
                                                rowsPerPage={rowsPerPage}
                                                page={page}                                                                                
                                                onPageChange={ handleChangePage }
                                                onRowsPerPageChange={ handleChangeRowsPerPage }
                                                ActionsComponent={ TablePaginationActions }

                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                      return '' + from + '-' + to + ' de ' + count
                                                    }
                                                }
                                            />
                                        </TableRow>

                                    </TableFooter>

                                </Table>
                            
                            </TableContainer>

                        </Grid>           
                        
                    </Grid>
                    
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button 
                        color="secondary" 
                        onClick={ CerrarModal }
                    >
                        Cancelar
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}